<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  props: ["form","disabled"],
  mixins: [pagination, tableSearch],
  data() {
    return {
      isLoading: false,
      implements_by_facility: [],
      isAlreadyLoadData: false
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.options_tables_implements_by_facility;
      const sendApiImplementsByFacility = await this.$http.get(url, {});
      const { status, data } = sendApiImplementsByFacility;

      if (status && data.result) {
        this.implements_by_facility = data.result;

        this.implements_by_facility.map(item => {
            var zz_implements = item.zz_implements.map(i => ({
              ...i,
              number_of_implements: this.form.implements_by_work_order.find(
                  formImplement => formImplement.zz_implement_id == i.id
                )?.number_of_implements ?? null
            }));
          item.zz_implements = zz_implements;

          return item;
        });
      }

      this.isLoading = false;
    },
    updateValue() {
      var dataSelected = []
      this.implements_by_facility.forEach((item, index) => {
        item.zz_implements.forEach((i, indexImplement) => {
          if (i.number_of_implements != null && i.number_of_implements > 0) {
            dataSelected.push({
              zz_implement_id: i.id,
              implement: i.implement,
              number_of_implements: i.number_of_implements
            });
          }
        });
      });

      this.$emit("changeData", dataSelected);
      this.$bvModal.hide("choose-implements");
    },
    formatterPositiveNumber(value){
      return Math.abs(value)
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "場所",
          value: "facility",
          sortable: true,
          with: 20
        },
        {
          text: "使用道具",
          value: "implement",
          sortable: false,
          with: 10
        },
        {
          text: "数量",
          value: "number_of_implements",
          sortable: false,
          with: 10
        }
      ];
    }
  }
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.choose-implements
      class="btn btn-primary waves-effect waves-light"
      :disabled="disabled"
    >
      <i class='far fa-list-alt'></i> 使用道具を選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="choose-implements"
      centered
      title-class="font-18"
      hide-footer
      title="使用道具一覧"
      scrollable
      @show="getData"
      @hidden="$emit('modalHidden', 'key_implements')"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in implements_by_facility">
                <tr>
                  <td :rowspan="item.zz_implements.length">
                    {{ item.facility }}
                  </td>
                  <td>
                    {{ item.zz_implements[0].implement }}
                  </td>
                  <td>
                    <b-form-input
                      :formatter="formatterPositiveNumber"
                      min="0"
                      type="number"
                      class="w-50"
                      v-model="item.zz_implements[0].number_of_implements"
                    ></b-form-input>
                  </td>
                </tr>
                <tr
                  v-for="(implement, indexImplement) in item.zz_implements"
                  v-if="indexImplement != 0 && item.zz_implements.length > 1"
                >
                  <td>
                    {{ implement.implement }}
                  </td>
                  <td>
                    <b-form-input
                      :formatter="formatterPositiveNumber"
                      min="0"
                      type="number"
                      class="w-50"
                      v-model="implement.number_of_implements"
                    ></b-form-input>
                  </td>
                </tr>
              </template>
              <tr v-if="!implements_by_facility.length && !isLoading">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
          <div class="d-flex justify-content-end mt-2">
            <button
              @click="updateValue"
              class="btn btn-primary w-md waves-effect waves-light"
            >
              <i class='fas fa-check'></i> 確定
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
